import React, { useState, useEffect } from 'react';
import '../styles/MenuStyle.css';

export default function Menu() {
    const [activeSection, setActiveSection] = useState('welcome-section');

    useEffect(() => {
        const sectionIds = ['welcome-section', 'about', 'projects', 'contact'];

        const handleIntersection = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActiveSection(entry.target.id);
                }
            });
        };

        const observer = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: '0px',
            threshold: 0.5,
        });

        sectionIds.forEach((sectionId) => {
            const target = document.getElementById(sectionId);
            if (target) {
                observer.observe(target);
            }
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    const handleMenuClick = (sectionId) => {
        const target = document.getElementById(sectionId);
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' }); // Défilement en douceur
            setActiveSection(sectionId);
        }
    };

    return (
        <nav id="navbar">
            <div className="logo-container">
                <a href="/#welcome-section">
                    <div className={"Menu-logo"}></div>
                </a>
            </div>
            <ul className="nav-menu" id="nav-menu">
                <li>
                    <a href="/#welcome-section" className={`nav-link ${activeSection === 'welcome-section' ? 'active' : ''}`} onClick={() => handleMenuClick('welcome-section')}>
                        <i className="fas fa-home"></i>
                    </a>
                </li>
                <li>
                    <a href="/#about" className={`nav-link ${activeSection === 'about' ? 'active' : ''}`} onClick={() => handleMenuClick('about')}>
                        <i className="fa fa-user"></i>
                    </a>
                </li>
                <li>
                    <a href="/#projects" className={`nav-link ${activeSection === 'projects' ? 'active' : ''}`} onClick={() => handleMenuClick('projects')}>
                        <i className="fas fa-cog"></i>
                    </a>
                </li>
                <li>
                    <a href="/#contact" className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`} onClick={() => handleMenuClick('contact')}>
                        <i className="fas fa-envelope"></i>
                    </a>
                </li>
            </ul>
            <ul className="social-menu">
                <li><a href="https://github.com/SLATTY54" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a></li>
                <li><a href="https://twitter.com/Kinzelin2" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a></li>
                <li><a href="https://www.linkedin.com/in/remy-kinzelin-129a1b1a0/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a></li>
            </ul>
        </nav>
    );
}
